import i18n from '../../../i18n/i18n';

export default {
  custom: {
    login: {
      required: () => i18n.t('login.validator.login')
    },
    password: {
      required: () => i18n.t('login.validator.password')
    }
  }
}
